(function () {
  'use strict';

  /* @ngdoc object
   * @name socialIntegration
   * @description
   *
   */
  angular
    .module('socialIntegration', [
      'ui.router'
    ]);
}());
